<template>
  <div>
    <input v-if="discount.id"
           v-model="discount.id"
           type="hidden"
           name="invoice[discount_attributes][id]">

    <div v-if="discountEnabled"
         class="line-items-footer-item px-i flex-nowrap discount-summary">
      <div class="line-items-footer-item-start flex-grow-1">
        <div class="mb-2 mb-md-0">
          Discount
        </div>

        <div class="line-items-footer-item-start-input mx-md-auto">
          <div class="custom-input-group">
            <div class="input-group custom-input-group-input">
              <template v-if="discount.percentage">
                <input v-model.number="discount.rate"
                       inputmode="decimal"
                       type="text"
                       required="required"
                       placeholder="0"
                       name="invoice[discount_attributes][rate]"
                       class="form-control custom-input-group-input-field text-center">
              </template>
              <template v-else>
                <input v-model.number="discount.rate"
                       type="hidden"
                       required="true"
                       name="invoice[discount_attributes][rate]">
                <currency-input v-model.number="discount.rate"
                                type="text"
                                class="form-control custom-input-group-input-field text-center"
                                :currency="null"
                                :distraction-free="false"
                                :placeholder="placeholderPrecision"
                                :precision="currencyPrecision"
                                required="true" />
              </template>
              <div class="input-group-prepend custom-input-group-input-select">
                <select
                  v-model="discount.percentage"
                  name="invoice[discount_attributes][percentage]"
                  class="custom-select custom-input">
                  <option :value="false">
                    {{ selectedCurrency.sign }}
                  </option>
                  <option :value="true">
                    %
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <input v-model="discountAmount"
               type="hidden"
               name="invoice[discount_attributes][amount]">
      </div>

      <div class="line-items-footer-item-end discount-summary-amount-js">
        {{ formattedDiscountAmount }}
      </div>
    </div>

    <input v-if="!discountEnabled && discount.id"
           type="hidden"
           value="true"
           name="invoice[discount_attributes][_destroy]">
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";

import { formatCurrency } from "@helpers";

export default {
  computed: {
    ...mapFields("lineItems", [
      "discount",
      "discountEnabled"
    ]),

    ...mapGetters("lineItems", [
      "discountAmount",
      "selectedCurrency"
    ]),

    formattedDiscountAmount () {
      let result = formatCurrency(this.discountAmount, this.selectedCurrency.iso_code);

      return this.discountAmount === 0 ? result : `-${result}`;
    },

    currencyPrecision () {
      if (this.selectedCurrency === "LBP") {
        return 0;
      } else {
        return 2;
      }
    },

    placeholderPrecision () {
      if (this.selectedCurrency === "LBP") {
        return "0";
      } else {
        return "0.00";
      }
    }
  }
};
</script>
